"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.media = void 0;

var _mediaCapture = require("./media-capture");

var media = {
  cameraCaptureControl: _mediaCapture.cameraCaptureControl,
  cameraButton: _mediaCapture.cameraButton
};
exports.media = media;
//# sourceMappingURL=index.js.map